import { Check } from 'lucide-react';
import { copy, type Language } from '../i18n.js';

export function Stepper({ current, language }: { current: 1 | 2 | 3 | 4 | 5; language: Language }) {
  return (
    <ol className="stepper" aria-label="Report progress">
      {copy[language].steps.map((label, index) => {
        const step = index + 1;
        const completed = current > step;
        return (
          <li
            className={`step ${current === step ? 'step-current' : ''} ${completed ? 'step-complete' : ''}`}
            key={label}
            aria-current={current === step ? 'step' : undefined}
          >
            <span className="step-marker">
              {completed ? <Check size={16} aria-hidden /> : step}
            </span>
            <span className="step-label">{label}</span>
            {step === 3 ? <span className="step-optional">{copy[language].optional}</span> : null}
          </li>
        );
      })}
    </ol>
  );
}
